import RecipientRepository from "@/repositories/monitorExams/RecipientRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'recipient',
    namespaced: true,
    state: {
        ...makeState(),
        isLoadingCurrent: {
            recipient: false,
            orders: false,
            reports: false,
            orderExams: false,
            reportExams: false,
        },
        current: {
            identifier: null,
            orders: [],
            reports: []
        },
        currentMonitor: null
    },
    getters: {
        ...makeGetters(),

        isLoadingCurrent(state) {
            return state.isLoadingCurrent
        },
        currentMonitor(state) {
            return state.currentMonitor
        }
    },
    mutations: {
        ...makeMutations(),

        setCurrentLoading(state, object) {
            state.isLoadingCurrent = {
                ...state.isLoadingCurrent,
                ...object
            }
        },
        setCurrentMonitor(state, string) {
            state.currentMonitor = string
        }
    },
    actions: {
        async listAll({commit, state}, params) {
            commit('setLoading', true)
            await RecipientRepository.listAll({...params, ...state.pagination})
                .then(response => {
                    commit('setPagination', {
                        page: response.data.current_page,
                        per_page: response.data.per_page,
                        total: response.data.total
                    })
                    commit('setAll', response.data.data)
                }).catch(console.error)
            commit('setLoading', false)
        },
        async listOne({commit, state}) {
            commit('setCurrentLoading', {recipient: true})
            await RecipientRepository.listOne(state.currentMonitor)
                .then(response => {
                    const current = response.data.data
                    if (current instanceof Array) {
                        commit('setCurrent', [])
                        current.map(recipient => {
                            const obj = {...recipient, orders: [], reports: []}
                            commit('setCurrent', [...state.current, obj])
                        })
                    }

                    if (!current instanceof Array) {
                        commit('setCurrent', {...response.data.data, orders: [], reports: []})
                    }
                }).catch(console.error)
            commit('setCurrentLoading', {recipient: false})
        },
        async listOrders({commit, state}, recipientId) {
            commit('setCurrentLoading', {orders: true})
            await RecipientRepository.listOrders(recipientId)
                .then(response => {
                    if (state.current instanceof Array) {
                        commit('setCurrent', state.current.map(recipient => {
                            return recipient.id === recipientId ? {...recipient, orders: response.data.data} : recipient
                        }))
                    } else {
                        commit('setCurrent', {...state.current, orders: response.data.data})
                    }
                }).catch(console.error)
            commit('setCurrentLoading', {orders: false})
        }, 
        async listOrdersByVnsId({commit, state}, payload) {
            commit('setCurrentLoading', {orders: true})
            await RecipientRepository.listOrdersByVnsId(payload)
                .then(response => {
                    if (state.current instanceof Array) {
                        commit('setCurrent', state.current.map(recipient => {
                            return recipient.id === payload.recipientId ? {...recipient, orders: response.data.data} : recipient
                        }))
                    } else {
                        commit('setCurrent', {...state.current, orders: response.data.data})
                    }
                }).catch(console.error)
            commit('setCurrentLoading', {orders: false})
        },
        async listReports({commit, state}, recipientId) {
            commit('setCurrentLoading', {reports: true})
            await RecipientRepository.listReports(recipientId)
                .then(response => {
                    if (state.current instanceof Array) {
                        commit('setCurrent', state.current.map(recipient => {
                            return recipient.id === recipientId ? {
                                ...recipient,
                                reports: response.data.data
                            } : recipient
                        }))
                    } else {
                        commit('setCurrent', {...state.current, reports: response.data.data})
                    }
                }).catch(console.error)
            commit('setCurrentLoading', {reports: false})
        },
        async listReportsByVnsId({commit, state}, payload) {
            commit('setCurrentLoading', {reports: true})
            await RecipientRepository.listReportsByVnsId(payload)
                .then(response => {
                    if (state.current instanceof Array) {
                        commit('setCurrent', state.current.map(recipient => {
                            return recipient.id === payload.recipientId ? {
                                ...recipient,
                                reports: response.data.data
                            } : recipient
                        }))
                    } else {
                        commit('setCurrent', {...state.current, reports: response.data.data})
                    }
                }).catch(console.error)
            commit('setCurrentLoading', {reports: false})
        },
        async listOrderExams({commit, state}, orderId) {
            commit('setCurrentLoading', {orderExams: true})
            await RecipientRepository.listOrderExams(orderId)
                .then(response => {
                    if (state.current instanceof Array) {
                        commit('setCurrent', state.current.map(recipient => {
                            return {
                                ...recipient,
                                orders: recipient.orders.map(order => {
                                    return order.id === orderId ? {...order, exams: response.data.data} : order
                                })
                            }
                        }))
                    } else {
                        commit('setCurrent', {
                            ...state.current,
                            orders: state.current.orders.map(order => {
                                return order.id === orderId ? {...order, exams: response.data.data} : order
                            })
                        })
                    }
                }).catch(console.error)
            commit('setCurrentLoading', {orderExams: false})
        },
        async listReportExams({commit, state}, reportId) {
            commit('setCurrentLoading', {reportExams: true})
            await RecipientRepository.listReportExams(reportId)
                .then(response => {
                    if (state.current instanceof Array) {
                        commit('setCurrent', state.current.map(recipient => {
                            return {
                                ...recipient,
                                reports: recipient.reports.map(report => {
                                    return report.id === reportId ? {...report, exams: response.data.data} : report
                                })
                            }
                        }))
                    } else {
                        commit('setCurrent', {
                            ...state.current,
                            reports: state.current.reports.map(report => {
                                return report.id === reportId ? {...report, exams: response.data.data} : report
                            })
                        })
                    }
                }).catch(console.error)
            commit('setCurrentLoading', {reportExams: false})
        }
    }
}
